import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-amena-index',
    templateUrl: './amena-index.component.html',
    styleUrls: ['./amena-index.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class AmenaIndexComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    ngOnInit(): void {
    }

    navigateTo(url: string) {
        this.router.navigate([url]);
    }

}
